import { mount } from "svelte";

import Signup from "../pages/Signup/Signup.svelte";

export const bindSignup = () => {
  const target = document.getElementById("signup-wrapper");
  return mount(Signup, {
    target,
  });
};
